import React from 'react';
import { Mail } from 'lucide-react';
import SiameseAILogoIcon from '../icons/SiameseAILogoIcon';

const CONTACT_EMAIL = 'hello@siameseai.com';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/60 mt-24">
      <div className="mx-auto max-w-6xl px-6 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center">
          <SiameseAILogoIcon size={22} className="opacity-70" />
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-xs text-muted-foreground">
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="inline-flex items-center gap-2 hover:text-primary transition-colors"
          >
            <Mail size={14} strokeWidth={1.6} />
            {CONTACT_EMAIL}
          </a>
          <span className="opacity-60">© {year} SiameseAI, Inc.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
